








import { defineComponent } from 'vue-demi';

export default defineComponent({
  name: 'NormalThemeHeader',
  setup() {},
});
